import { RootState } from '../../../store';

export const getChallengesSelector = (state: RootState) => state.challenges.challenges;
export const getChallengesLoadMoreSelector = (state: RootState) => state.challenges.loadMore;
export const getChallengesLoadingSelector = (state: RootState) => state.challenges.isLoading;
export const getChallengesPageSelector = (state: RootState) => state.challenges.page;
